import { Navigate, useLocation } from 'react-router';
import { INDEX_PATH } from 'routes/constants';
import { ReactNode } from 'react';

import { isTeamInvitationQuery } from 'domains/userSettings/utils/isTeamInvitationQuery';

interface ITeamInvitationGuardProps {
  children?: ReactNode;
}

export const TeamInvitationGuard = ({
  children,
}: ITeamInvitationGuardProps) => {
  const location = useLocation();

  const isTeamInvitation = isTeamInvitationQuery(location.search || '');

  if (isTeamInvitation) {
    return <>{children}</>;
  }

  return <Navigate to={INDEX_PATH} replace />;
};
